import { DatePicker, Select, Option } from '@adeccoux/tag-ds';

import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import SesHeader from "../header";
import { POST_DEMOGRAPHIC_DATA } from "../../util/constants";
import { postCall } from "../../util/resources";
import DisplayButton from '../../util/displaybutton';


const Demographics = () => {
  const [key, setKey] = useState(false);
  const clientCobranding = sessionStorage.getItem('clientLogo');
  const phrases = JSON.parse(sessionStorage.getItem('phrases'));
  const navigate = useNavigate();
  const location = useLocation();
  const [educationList, seteducationList] = useState([]);
  const [nationalityList, setnationalityList] = useState([]);
  const [genderList, setgenderList] = useState([]);
  const [gender, setgender] = useState("");
  const [education, seteducation] = useState("");
  const [national, setnational] = useState("");
  const [datep, setdatep] = useState("");
  const [refresh, setRefresh] = useState(true);
  const today = Math.floor(Date.now());
  useEffect(() => {
    seteducationList(location.state.user.siteConfig.demographicConfig?.educationList);
    setnationalityList(location.state.user.siteConfig.demographicConfig?.nationalityList);
    let includeOtherGender = location.state.user.siteConfig.otherGenderIncluded;
    let glist = [
      {
        content: phrases?.["14879"],
        value: "M",
      },
      {
        content: phrases?.["14880"],
        value: "F",
      },
      {
        content: "Prefer not to say", //  phrases?.['10022089'] -- need to add in phrases
        value: "P",
      },
    ];
    if (includeOtherGender === "Y") {
      glist.splice(2, 0, {
        content: phrases?.["26000026"],
        value: "O",
      });
    }
    setgenderList(glist);
  }, [refresh]);

  const HandleDateChange = (e) => {
    setdatep(e);
  };

  const handleGender = (e) => {
    setgender(e);
  }
  const handleeducation = (e) => {
    seteducation(e);
  }
  const handlenational = (e) => {
    setnational(e);
  }
  const handleClearButtonClick = () => {
    setgender("");
    seteducation("");
    setnational("");
    setdatep(today);
    setKey(k => !k);
    setRefresh((prev) => !prev);
  };

  const handleButtonClick = () => {
    let formattedUser = structuredClone(location.state.user);
    let headers = { "x-xpert-session": formattedUser.sessionId };
    delete formattedUser.siteConfig;
    delete formattedUser.sessionId;

    if (datep !== "") {
      let date = new Date(datep);
      formattedUser.birthDate = date.getFullYear() + '-' + (date.getMonth() + 1).toString().padStart(2, '0') + '-' + date.getDate().toString().padStart(2, '0');
    }
    if (gender !== "") {
      formattedUser.gender = gender;
    }

    formattedUser = {
      ...formattedUser,
      educationId: education,
      ethnicityId: national,
    };
    let demResponse = true;
    postCall(POST_DEMOGRAPHIC_DATA, formattedUser, headers)
      .then(function ({ data }) {
        if (data === true) {
          demResponse = false;
          sessionStorage.setItem("demographics", true);
        } else {
          console.log("Demographic data not updated");
        }
      })
      .catch(function (error) {
        console.log("Error in saving demographic data", error);
      });


    navigate("/instructions", {
      state: {
        ...location.state,
        demographics: demResponse
      },
    });
  };

  return (
    <>
      <SesHeader clientCobranding={clientCobranding ? clientCobranding : false} />
      <div className="flex_col g3">
        <div className="flex_col g2">
          <div className="h3">{phrases?.['13386']}</div>
          <div> {phrases?.['15216']}</div>
          <div> {phrases?.['15310']}</div>
        </div>
        <hr />
      </div>

      <div className="flex_col g3 align-items_start xpert-align-self-stretch">
        <div className="flex_col g2 align-items_start xpert-align-self-stretch .xpert-align-self-center_mobile ">
          <div className="flex flex_col_mobile flex_col_tablet g2 align-items_start xpert-align-self-stretch xpert-align-self-center_mobile">
            <div className='flex_col g1 align-items_start xprt-flx-1'>
              <Select
                className="text_uppercase full-width xpert-max"
                label={phrases?.['13389']}
                id="genderList"
                name="genderList"
                placeholder="select an option"
                style={{ width: "auto" }}
                value={gender}
                onChange={handleGender}
              >
                <Option label="select an option" selected ></Option>
                {genderList.map((data, idxl) => (
                  <Option
                    key={idxl}
                    label={data.content}
                    value={data.value}
                  >
                    {data.content}
                  </Option>
                ))}
              </Select>
            </div>
            <div className='flex_col g1 align-items_start xprt-flx-1'>
              <label className="text_uppercase caption">{phrases?.['13393']}</label>
              <DatePicker key={key} className="dateNew xpert-align-self-stretch"
                name="datepicker" maxDate={today} selected={datep} onChange={HandleDateChange}
              />
            </div>
          </div>
          <div className="flex flex_col_mobile flex_col_tablet g2 align-items_start xpert-align-self-stretch xpert-align-self-center_mobile">
            <div className='flex_col g1 align-items_start xprt-flx-1'>
              <Select
                label={phrases?.['13397']}
                className="text_uppercase full-width xpert-max"
                id="educationList"
                name="educationList"
                placeholder="select an option"
                style={{ width: "auto" }}
                value={education}
                onChange={handleeducation}
              >
                <Option label="select an option" selected ></Option>
                {educationList && Object.keys(educationList).map((idxl) => (
                  <Option
                    key={idxl}
                    label={educationList[idxl].text}
                    value={educationList[idxl].id}
                  >
                    {educationList[idxl].text}
                  </Option>
                ))}
              </Select>
            </div>
            <div className='flex_col g1 align-items_start xprt-flx-1'>
              <Select
                className="text_uppercase full-width xpert-max"
                label={phrases?.['13398']}
                id="nationalityList"
                name="nationalityList"
                placeholder="select an option"
                style={{ width: "auto" }}
                value={national}
                onChange={handlenational}
              >
                <Option label="select an option" selected ></Option>
                {nationalityList && Object.keys(nationalityList).map((idxl) => (
                  <Option
                    key={idxl}
                    label={nationalityList[idxl].text}
                    value={nationalityList[idxl].id}
                  >
                    {nationalityList[idxl].text}
                  </Option>
                ))}
                ;
              </Select>
            </div>
          </div>
        </div>
      </div>


      <DisplayButton
        buttons={[
          <></>,
          <>
            <a role="link" className="text_uppercase full-width_mobile justify-content_center" onClick={() => handleClearButtonClick()}  >
              Clear all
            </a>
            <button
              className="button-primary text_uppercase full-width_mobile"
              onClick={() => handleButtonClick()}
            >
              {phrases?.["10976"]}
              <span className="material-icons-outlined">
                east
              </span>
            </button>
          </>
        ]} />
    </>
  );
}

export default Demographics;